import React from 'react'
import Link from 'redux-first-router-link'
import { CONVERSATIONS_PAGE } from 'ducks/reports/conversations/pages'
import { HAPPINESS_PAGE } from 'ducks/reports/happiness/pages'
import { PRODUCTIVITY_PAGE } from 'ducks/reports/productivity/pages'
import { KB_PAGE } from 'ducks/reports/kb/pages'
import {
  knowledge as KnowledgeBaseIcon,
  conversations as ConversationsIcon,
  productivity as ProductivityIcon,
  happiness as HappinessIcon,
} from 'assets/icons/groove/v2'
import ButtonWithMenu from '../ButtonWithMenu'
import { styles } from './styles'

const toConversationsPage = {
  type: CONVERSATIONS_PAGE,
}

const toProductivityPage = {
  type: PRODUCTIVITY_PAGE,
}

const toHappinessPage = {
  type: HAPPINESS_PAGE,
}

const toKnowledgeBasePage = {
  type: KB_PAGE,
}

const activeColor = '#CFEBFF'

const Menu = ({ onClose }) => {
  return (
    <ButtonWithMenu.Menu css={styles.menu}>
      <ButtonWithMenu.Menu.Item
        icon={<ConversationsIcon className="md-icon" />}
        title="Conversations"
        copy="Reports on conversation and keyword volume + busiest times."
        as={Link}
        to={toConversationsPage}
        onClick={onClose}
        activeColor={activeColor}
        dataTestId="Conversations"
      />
      <ButtonWithMenu.Menu.Item
        icon={<ProductivityIcon className="md-icon" />}
        title="Productivity"
        copy="A high-level view of your team’s productivity."
        as={Link}
        to={toProductivityPage}
        onClick={onClose}
        activeColor={activeColor}
      />
      <ButtonWithMenu.Menu.Item
        icon={<HappinessIcon />}
        title="Happiness"
        copy="Understand customer sentiment with satisfaction reports."
        as={Link}
        to={toHappinessPage}
        onClick={onClose}
        activeColor={activeColor}
      />
      <ButtonWithMenu.Menu.Item
        icon={<KnowledgeBaseIcon className="md-icon" />}
        title="Knowledge base"
        copy="See detailed reports on your Knowledge Base traffic."
        as={Link}
        to={toKnowledgeBasePage}
        onClick={onClose}
        activeColor={activeColor}
      />
    </ButtonWithMenu.Menu>
  )
}

export default Menu
